// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1essx","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__2pUS2"};